"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UIUtils_1 = require("../modules/UIUtils");
exports.i_key_value_item_data_key_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
exports.i_key_value_item_data_key_value = UIUtils_1.UIUtils.IProp2Str(function (o) { o.value; });



//////////////////
// WEBPACK FOOTER
// ./src/shared/controllers/KeyValueItem.ts
// module id = 795
// module chunks = 0